<div class="w-full bg-white rounded-[0.25rem] border border-slate-200 shadow-sm" cdkAccordion
    [ngClass]="[absoluteContent ? 'absolute' : '', accordionItem.expanded ? '!shadow-lg' : '']">
    <cdk-accordion-item #accordionItem="cdkAccordionItem">
        <header class="border-slate-100 cursor-pointer" [ngClass]="accordionItem.expanded ? 'border-b' : ''"
            (click)="accordionItem.toggle();">
            <div class="flex justify-between items-center w-full">
                <div>
                    <h2 class="font-semibold text-slate-800 form-input border-none !shadow-none">Inventario de Zonas
                    </h2>
                </div>
                <div>
                    <button
                        class="btn-sm border-slate-200 hover:border-slate-300 text-slate-600 h-fit px-1 border-none !shadow-none">
                        <div class="w-6 h-6 grid place-content-center"
                            [ngClass]="accordionItem.expanded ? 'rotate-180' : 'rotate-0'">
                            <i class="fa-duotone fa-chevron-down" style="font-size: 1rem;"></i>
                        </div>
                    </button>
                </div>
            </div>
        </header>
        <div class="flex-col h-full bg-white" [ngClass]="accordionItem.expanded ? 'flex' : 'hidden'">
            <div class="grow px-5 pt-3 pb-1 max-h-60 overflow-y-auto">
                <div class="overflow-x-auto">
                    <table class="table-auto w-full">
                        <thead class="text-xs uppercase text-slate-400">
                            <tr>
                                <th class="py-2 w-1/2">
                                    <div class="font-semibold text-left">Zonas</div>
                                </th>
                                <!-- <th class="py-2 w-1/2">
                                    <div class="font-semibold text-center">Promo</div>
                                </th> -->
                                <th class="py-2 w-1/2" *ngIf="showAvailability">
                                    <div class="font-semibold text-right">Disponible</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="text-sm divide-y divide-slate-100"> 
                            <tr *ngFor="let item of pricing; let i = index">
                                <td class="py-2 flex items-center">
                                    <div>
                                        <div class="w-6 h-6 grid place-content-center mr-2 rounded-sm "
                                            [style]="'background-color:'+ item.seats_io_zone_color">
                                        </div>
                                    </div>
                                    <div class="text-left">
                                        {{item.zone_name}}

                                    </div>
                                </td>
                              
                                <td class="py-2" *ngIf="showAvailability">
                                    <div class="font-medium text-right text-slate-800">
                                        {{item.ticket_price}}
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="!pricing[0]">
                                <td class="py-2">
                                    <div class="text-left">No hay zonas disponibles</div>
                                </td> 
                            </tr>
                    
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </cdk-accordion-item>
</div>